import styled from 'styled-components';

const PagePortalHolder = styled.div`
	grid-area: content;
	overflow: auto;
	width: 100%;
	margin: 0 auto;
	min-height: 600px;
	a {
		text-decoration: none;
	}
	section {
		display: flow-root;
		width: auto;
		margin: 0px 15px;
	}
	h1 {
		position: relative;
		background-color: rgb(60, 63, 71);
		color: white;
		font-size: 24px;
		width: 100%;
		left: 0;
		padding-left: 25px;
		min-height: 50px;
		line-height: 50px;
	    margin-top: 0px;
		margin-bottom: 0px;
		text-indent: 35px;
		font-family: 'Quicksand', sans-serif;
		font-weight: 700;
		img {
			position: absolute;
			top: 7px;
			left: 20px;
			width: 35px;
			height: 35px;
			filter: invert(100%) sepia(94%) saturate(26%) hue-rotate(353deg) brightness(106%) contrast(105%);
			opacity: 0.4;
		}
	}
	.house-left {
		h2 {
			margin-left: 25px;
		}
		&.content__left {
			margin-top: 0px;
			width: 100%;
			@media screen and (min-width: 1025px) {
				width: 75%;	
			}
			.featured-container {
				margin-top: 10px;
				margin-right: 20px;
				@media only screen and (max-width: 548px) {
					margin-right: 0;
					margin-left: 0;
				}
			}
		}	
	}
	.latest-house-videos.content__right {
		margin-left: 0px;
		margin-top: 0px;
	}
	.committee {
		p {
			text-align: center;
			font-size: 14px;
			margin-top: 10px;
			color: #000;
		}		
		@media only screen and (min-width: 768px) {
			width: 22.8%;
			float: left;
			height: 150px;
			margin-bottom: 10px;
			margin-left: 8px;
			margin-right: 8px;
			background-color: #fff;
			padding-left: 5px;
		}
	}				
	.color-green,
	.color-joint {
		text-align: center;
		border: 2px solid;
		margin-top: 40px;
		width: 85px;
		font-size: 20px;
		margin-left: auto;
		margin-right: auto;
		font-weight: 400;
		color: #fff;	
	}	
	.color-joint {
		border: 2px solid #3072ab;
		background-color: #3072ab;
	}	

	.committees-container {
		padding: 0px;
		margin: 0px;
		margin-left: 7px;
		li {
			list-style: none;
			margin-bottom: 10px;
			margin-left: 10px;
			margin-right: 10px;
			background-color: #fff;
			padding-left: 5px;
			padding-right: 5px;
		}
	}

	.committees,
	.latest-committees {
		h2 {
			margin-left: 10px;
		}
	}
`;

export default PagePortalHolder;

